module.exports = __webpack_public_path__ + "img/02_heated_area.f9270b73.svg";